/**
 * Scryfall-Bildvarianten für `CardImage`.
 *
 * Scryfall legt die Bildgröße im ersten Pfadsegment der Bild-URL ab, alles andere ist für
 * alle Varianten gleich — auch die Zahl hinter `?`, ein Cache-Schlüssel von Scryfall:
 *   https://cards.scryfall.io/normal/front/a/c/<id>.jpg?1783910791
 * Die App speichert die `normal`-Form; `small` und `large` werden daraus abgeleitet.
 */
const NORMAL_PREFIX = 'https://cards.scryfall.io/normal/';

/** Breite der JPG-Varianten in Pixeln (Höhe jeweils 7/5 davon). */
const SCRYFALL_IMAGE_WIDTHS = { small: 146, normal: 488, large: 672 };

/**
 * `srcset`-Wert mit den drei Varianten und ihren Breiten-Deskriptoren für eine URL der
 * `normal`-Form; `null` für jede andere Eingabe (anderer Host, anderes Segment, Platzhalter
 * wie `card-back`, leer, `null`).
 */
export function scryfallSrcSet(url) {
  if (typeof url !== 'string' || !url.startsWith(NORMAL_PREFIX)) return null;
  const rest = url.slice(NORMAL_PREFIX.length);
  return Object.entries(SCRYFALL_IMAGE_WIDTHS)
    .map(([variant, width]) => `https://cards.scryfall.io/${variant}/${rest} ${width}w`)
    .join(', ');
}
